import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton, Switch } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import { ProductFormData } from "@/components/screens/ProductFormPage/types";
import useSkuData from "@/hooks/data/use-sku-data";
import usePopOver from "@/hooks/use-popover";
import { ISku } from "@/interfaces/sku.interface";
import { SkuFormMessages } from "@/messages/sku/sku-form.messages";
import { useProductFormStateContext } from "@/contexts/product-form-state-context";

import SkuPopover from "../SkuPopover";
import { SkuImageCell } from "./SkuImageCell";

interface Props {
  sku: ISku;
  index: number;
  messages: SkuFormMessages;
  onRemove: (sku: ISku) => void;
  openDialog: (isEditing: boolean) => void;
}

export function SkuTableRow({ messages, sku, index, onRemove, openDialog }: Props) {
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<ISku>();
  const { setFieldValue, values } = useFormikContext<ProductFormData>();
  const { code, title, isActive, formattedPrice, formattedStock, formattedVariations } = useSkuData(
    { sku, productVariations: values.variations }
  );
  const { savedImages } = useProductFormStateContext();

  const handleToggleActive = async (sku: ISku) => {
    const updatedSkus = values.skus.map((s) => (s === sku ? { ...s, active: !s.active } : s));
    setFieldValue("skus", updatedSkus);
  };

  return (
    <TableRow index={index}>
      <SkuImageCell sku={sku} productImages={savedImages} />
      <TableCell>{code}</TableCell>
      <TableCell>{title}</TableCell>
      <TableCell title={formattedVariations}>{formattedVariations}</TableCell>
      <TableCell>{formattedStock}</TableCell>
      <TableCell>{formattedPrice}</TableCell>

      <TableCell>
        <Switch
          checked={isActive}
          onClick={(e) => {
            e.stopPropagation();
            handleToggleActive(sku);
          }}
        />
      </TableCell>

      <TableCell>
        <IconButton
          onClick={(e) => {
            openPopover(e, sku);
          }}
        >
          <MoreHorizIcon />
        </IconButton>

        {selected && (
          <SkuPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selectedSku={selected}
            onRemove={onRemove}
            openDialog={openDialog}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
